exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".my-card-modal-body{padding-top:0}.no-min-height .modal-content{height:0}.modal-content{border:1px solid #ffc000}#profile-card-modal{max-width:800px}@media(min-width: 577px){#profile-card-modal{max-width:80%}}@media(min-width: 900px){#profile-card-modal{max-width:800px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/modals/ProfileCardModal/styles.scss
// module id = 758
// module chunks = 0